import { useEffect, useState, useCallback } from "react";
import { useConfirm } from "@/components/ConfirmProvider";
import api, { apiError } from "@/lib/api";
import { toast } from "sonner";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import Pagination, { PAGE_SIZE } from "@/components/Pagination";
import { Plus, Pencil, Trash2 } from "lucide-react";

export default function PaymentMethods() {
  const [list, setList] = useState([]);
  const { confirm } = useConfirm();
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState({ name: "", active: true });
  const [editId, setEditId] = useState(null);
  const [page, setPage] = useState(1);

  const load = useCallback(() => api.get("/payment-methods").then((r) => setList(r.data)), []);
  useEffect(() => { load(); }, [load]);
  const paged = list.slice((page - 1) * PAGE_SIZE, page * PAGE_SIZE);

  const save = async () => {
    try {
      if (editId) await api.put(`/payment-methods/${editId}`, form); else await api.post("/payment-methods", form);
      toast.success("Enregistré"); setOpen(false); load();
    } catch (e) { toast.error(apiError(e)); }
  };
  const toggle = async (m) => { try { await api.put(`/payment-methods/${m.id}`, { ...m, active: !m.active }); load(); } catch (e) { toast.error(apiError(e)); } };
  const remove = async (id) => { if (!(await confirm({ title: "Supprimer le mode de paiement", description: "Supprimer ce mode de paiement ?", confirmText: "Supprimer", danger: true }))) return; try { await api.delete(`/payment-methods/${id}`); toast.success("Supprimé"); load(); } catch (e) { toast.error(apiError(e)); } };

  return (
    <div className="space-y-5">
      <div className="flex items-center justify-between">
        <h1 className="text-2xl font-bold text-slate-800">Moyens de paiement</h1>
        <Button data-testid="add-pm-btn" onClick={() => { setForm({ name: "", active: true }); setEditId(null); setOpen(true); }} className="bg-sky-600 hover:bg-sky-700"><Plus size={18} className="mr-2" /> Nouveau</Button>
      </div>
      <Card className="overflow-hidden">
        <table className="data-table w-full text-sm">
          <thead className="bg-slate-50 text-slate-500 text-left"><tr><th className="px-4 py-3">Nom</th><th className="px-4 py-3">Actif</th><th className="px-4 py-3 text-right">Actions</th></tr></thead>
          <tbody>
            {paged.map((m) => (
              <tr key={m.id} data-testid={`pm-row-${m.id}`} className="border-t border-slate-100">
                <td className="px-4 py-3 font-medium text-slate-800">{m.name}</td>
                <td className="px-4 py-3"><Switch data-testid={`toggle-pm-${m.id}`} checked={m.active} onCheckedChange={() => toggle(m)} /></td>
                <td className="px-4 py-3 text-right space-x-1">
                  <Button size="icon" variant="ghost" onClick={() => { setForm({ name: m.name, active: m.active }); setEditId(m.id); setOpen(true); }}><Pencil size={16} /></Button>
                  <Button size="icon" variant="ghost" className="text-red-600" onClick={() => remove(m.id)}><Trash2 size={16} /></Button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </Card>

      <Pagination page={page} total={list.length} onPage={setPage} />

      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent>
          <DialogHeader><DialogTitle>{editId ? "Modifier" : "Nouveau moyen de paiement"}</DialogTitle></DialogHeader>
          <div className="space-y-3">
            <div><Label>Nom</Label><Input data-testid="pm-name" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} /></div>
            <div className="flex items-center gap-2"><Switch checked={form.active} onCheckedChange={(v) => setForm({ ...form, active: v })} /><Label>Actif</Label></div>
          </div>
          <DialogFooter>
            <Button variant="outline" onClick={() => setOpen(false)}>Annuler</Button>
            <Button data-testid="save-pm-btn" onClick={save} className="bg-sky-600 hover:bg-sky-700">Enregistrer</Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </div>
  );
}
